/**
 * Internal SMB API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MovedFile { 
    src?: string;
    dest?: string;
    success?: boolean;
    moveError?: string;
    dataFileType?: MovedFile.DataFileTypeEnum;
    deviceId?: number;
    internalDropOffId?: number;
    externalDropOffId?: number;
    exportedAt?: string;
}
export namespace MovedFile {
    export const DataFileTypeEnum = {
        Gps: 'GPS',
        Mor: 'MOR',
        Adf: 'ADF',
        Adf3: 'ADF3',
        Csq: 'CSQ',
        ConfigCollar: 'CONFIG_COLLAR',
        InfoCollar: 'INFO_COLLAR',
        Report: 'REPORT',
        Prx: 'PRX',
        Sep: 'SEP',
        Vit: 'VIT',
        Mit: 'MIT',
        ConfigDropOff: 'CONFIG_DROP_OFF',
        InfoDropOff: 'INFO_DROP_OFF',
        DropOffKey: 'DROP_OFF_KEY',
        ConfigExternalDropOff: 'CONFIG_EXTERNAL_DROP_OFF',
        InfoExternalDropOff: 'INFO_EXTERNAL_DROP_OFF',
        Debug: 'DEBUG',
        ConfigTrap: 'CONFIG_TRAP',
        LogTrap: 'LOG_TRAP',
        InfoTrap: 'INFO_TRAP',
        AccBin: 'ACC_BIN',
        MagBin: 'MAG_BIN'
    } as const;
    export type DataFileTypeEnum = typeof DataFileTypeEnum[keyof typeof DataFileTypeEnum];
}


